'use strict';

var log = require('../../log/Log').channel('InfoController');
var defaults = require('../../defaults/Defaults');

angular.module('inara').controller('InfoController', InfoController);

InfoController.$inject = ['$scope', '$rootScope', '$state', 'Idle'];

function InfoController($scope, $rootScope, $state, Idle) {
    var oldOnBackButton = null;
    var idleEnabled;
    var offIdleTimeout = null;

    log.info('initializing');

    $scope.$on('$ionicView.enter', function () {
        oldOnBackButton = $rootScope.$ionicGoBack;
        $rootScope.$ionicGoBack = onBackButton;
        setIdleEnabled(defaults.inara.idleEnabled);
        setIdleTimeout(defaults.inara.idleTimeout);
        if (idleEnabled) {
            Idle.watch();
        } else {
            Idle.unwatch();
        }
        removeOnIdle();
        offIdleTimeout = $scope.$on('IdleTimeout', onIdleTimeout);
    });

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (fromState.name.startsWith('info.') && !toState.name.startsWith('info.')) {
            onLeaveView();
        }
    });

    function removeOnIdle() {
        if (offIdleTimeout !== null) {
            offIdleTimeout();
            offIdleTimeout = null;
        }
    }

    function setIdleEnabled(value) {
        idleEnabled = value;
    }

    function setIdleTimeout(value) {
        // Set the default here in case DeviceService isn't running
        var timeout = parseFloat(value) * 60;
        var limit = 2;

        if (timeout < limit) {
            log.error('setIdleTimeout: ' + timeout + ' limited to ' + limit);
            timeout = limit;
        }

        Idle.setIdle(1);
        Idle.setTimeout(timeout - 1); // subtract idle time to correct total
    }

    function onLeaveView() {
        if (oldOnBackButton !== null) {
            $rootScope.$ionicGoBack = oldOnBackButton;
            oldOnBackButton = null;
        }
        removeOnIdle();
    }

    function onBackButton() {
        goToStart();
    }

    function onIdleTimeout() {
        goToStart();
    }

    function goToStart() {
        $state.go('start');
    }
}

module.exports = InfoController;
